import React, { useState, useRef } from 'react';
import {
  makeStyles,
  Paper,
  Button,
} from '@material-ui/core';
import {
  PhotoSizeSelectLarge as PhotoSizeSelectLargeIcon,
  Remove as RemoveIcon,
  Undo as UndoIcon,
  Redo as RedoIcon,
} from '@material-ui/icons';

import { UdafSketch } from '@acclaim/udaf-kit';
import { TOOLS } from 'common/constants';
import EraserSvg from 'components/EraserSvg';

const { SketchField, Tools } = UdafSketch;

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  canvas: {
    width: '200px',
    height: '200px',
    margin: '0 20px',
  },
  tools: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '230px',
  },
  tool: {
    width: 'calc(50% - 6px)',
    margin: '3px',
    '& svg': {
      fontSize: '16px',
      marginRight: '5px',
    },
  },
}));

const canvasTools = [
  {
    name: 'Select',
    Icon: PhotoSizeSelectLargeIcon,
    type: 'Select',
  },
  ...TOOLS,
];

const Canvas = () => {
  const classes = useStyles();
  const [tool, setTool] = useState(Tools.Pencil);
  const [eraser, setEraser] = useState(false);
  const sketchRef = useRef();

  const handleUndo = () => {
    if (sketchRef.current.canUndo()) {
      sketchRef.current.undo();
    }
  };

  const handleRedo = () => {
    if (sketchRef.current.canRedo()) {
      sketchRef.current.redo();
    }
  };

  const handleToolChange = (type) => {
    sketchRef.current._fc.discardActiveObject();
    sketchRef.current._fc.requestRenderAll();
    setEraser(false);
    setTool(type);
  };

  const handleEraser = () => {
    setEraser(true);
    setTool(Tools.Pencil);
  };

  const renderTool = ({ name, Icon, type }) => {
    const toolType = Tools[type];

    return (
      <Button
        key={name}
        variant={toolType === tool && !eraser ? 'contained' : 'outlined'}
        color="primary"
        size="small"
        onClick={() => handleToolChange(toolType)}
        className={classes.tool}
      >
        <Icon />
        <span>{name}</span>
      </Button>
    );
  };

  return (
    <div className={classes.wrapper}>
      <Paper elevation={2} className={classes.canvas}>
        <SketchField
          name="collaborateSketch"
          height={200}
          width={200}
          tool={tool}
          lineColor={eraser ? 'white' : 'black'}
          lineWidth={eraser ? 20 : 8}
          ref={sketchRef}
          backgroundColor="white"
        />
      </Paper>
      <div className={classes.tools}>
        <Button
          color="primary"
          variant="outlined"
          size="small"
          className={classes.tool}
          onClick={handleUndo}
        >
          <UndoIcon />
          Undo
        </Button>
        <Button
          color="primary"
          variant="outlined"
          size="small"
          className={classes.tool}
          onClick={handleRedo}
        >
          <RedoIcon />
          Redo
        </Button>
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={sketchRef?.current?.removeSelected}
          className={classes.tool}
        >
          <RemoveIcon />
          <span>Remove</span>
        </Button>
        <Button
          variant={eraser ? 'contained' : 'outlined'}
          color="primary"
          size="small"
          onClick={handleEraser}
          className={classes.tool}
        >
          <EraserSvg />
          <span>Eraser</span>
        </Button>
        {canvasTools.map(renderTool)}
      </div>
    </div>
  );
};

export default Canvas;
